// extracted by css-extract-rspack-plugin
export default {"cls1":"ActionNav-cls1_m10","cls2":"ActionNav-cls2_Zld ActionNav-cls1_m10"};